export default __webpack_public_path__ + "static/media/22.0531eb42.png";